<script>
import baseMixin from '@/mixins/baseMixin'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BookingCreateHeaderV2',
  mixins: [baseMixin],
  props: {
    editMode: { type: Boolean, default: false },
    bookingId: { type: [String, Number], default: null },
  },
  data() {
    return {
      ...VuetifyTextClass,
      text: VuetifyColourClass.text,
    }
  },
  computed: {
    ...mapGetters({
      isSendToANZUK: 'bookings/isSendToANZUK',
      createBookingV2Header: 'bookings/createBookingV2Header',
      isLoadingCRUD: 'bookings/isLoadingCRUD',
      isLoadingEditBooking: 'bookings/isLoadingEditBooking',
      isLoadingBookingBlocks: 'locations/isLoadingBookingBlocks',
    }),
    pageTitle() {
      return this.$t('bookingCreate.breadcrumbTitle')
    },
    primaryActionLabel() {
      return this.isSendToANZUK
        ? this.$t('bookingCreate.submitBtn')
        : this.$t('bookingCreateV2.selectEducators')
    },
    primaryLoading() {
      return (
        this.isLoadingCRUD ||
        this.isLoadingBookingBlocks ||
        this.isLoadingEditBooking
      )
    },
    primaryDisabled() {
      const { isFormValid, formDirty } = this.createBookingV2Header
      return this.editMode ? !formDirty || !isFormValid : !isFormValid
    },
    primaryTooltip() {
      return this.createBookingV2Header.submitButtonTooltip
    },
  },
  methods: {
    ...mapActions({
      requestCreateBookingV2Submit: 'bookings/requestCreateBookingV2Submit',
    }),
  },
}
</script>

<template>
  <header
    class="white d-flex align-center justify-space-between w-100 pa-6"
    data-testid="booking-create-header-v2"
  >
    <div>
      <v-btn
        class="mb-1 pl-0 pr-1 text-sm-medium neutrals-grey-500-text"
        elevation="0"
        text
        data-test-btn="close-action"
        @click="$router.go(-1)"
      >
        <v-icon size="20" class="mr-2">mdi-chevron-left</v-icon>
        <span>{{ $t('general.leave') }}</span>
      </v-btn>
      <h1 class="display-sm-semibold my-0">
        {{ pageTitle }}
      </h1>
    </div>

    <v-tooltip bottom :disabled="!primaryDisabled || !primaryTooltip">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-btn
            class="text-md-semibold booking-create-header-button"
            data-test-btn="primary-action"
            elevation="0"
            color="primary"
            :disabled="primaryDisabled"
            :loading="primaryLoading"
            @click="requestCreateBookingV2Submit"
          >
            <transition name="fade-cycle-down" mode="out-in">
              <span :key="primaryActionLabel">{{ primaryActionLabel }}</span>
            </transition>
            <v-icon right size="20" class="white--text"
              >mdi-chevron-right</v-icon
            >
          </v-btn>
        </span>
      </template>
      <span data-testid="booking-create-header__submit-btn-tooltip-text">{{
        primaryTooltip
      }}</span>
    </v-tooltip>
  </header>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';
@import '@/styles/_r2b-colours.scss';

.booking-create-header-button {
  min-width: 0 !important;
  height: 47px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  letter-spacing: 0.15px;
  border-radius: 8px !important;
}

.outlined-border-grey {
  border-color: $neutrals-grey-200 !important;
}
</style>
